import { cx } from "../../lib/cx.js";
/* empty css         */
import { jsx } from "react/jsx-runtime";
//#region src/components/Text/Text.tsx
/**
* A run of text in a type role: muted or status-toned, meta-sized, semibold or mono,
* without inline styles. Everything it doesn't set comes from the surrounding text.
*/
function Text({ as: Element = "span", tone = "default", size, weight, mono = false, className, ...rest }) {
	return /* @__PURE__ */ jsx(Element, {
		...rest,
		className: cx("ds-text", tone !== "default" && `ds-text--${tone}`, size && `ds-text--${size}`, weight && `ds-text--${weight}`, (mono || Element === "code") && "ds-text--mono", className)
	});
}
//#endregion
export { Text };

//# sourceMappingURL=Text.js.map